import {Button} from "@/components/ui/button";
import styles from "./EditRdvButtonsCommit.module.css";
import Delete02Icon from "../../main/icons/delete-02-stroke-rounded.tsx";
import { useState } from "react";

interface EditRdvButtonsCommitProps {
  onSaveRdv: () => void;
  onCancelRdvEdit: () => void;
  onDeleteWithoutLogging: () => void;
  onCancelWithLogging: () => void;
  onAutoDelete: () => void;
  onPostPone: () => void;
  isSecretary: boolean;
}

const EditRdvButtonsCommit = (props: EditRdvButtonsCommitProps) => {
  const [showDeleteChoice, setShowDeleteChoice] = useState(false);
  const [flagPopupTop, setFlagPopupTop] = useState(0);
  const [flagPopupLeft, setFlagPopupLeft] = useState(0);
  const toggleDeleteChoice = (event: React.MouseEvent) => {
    event.stopPropagation();
    const target = event.currentTarget;
    setShowDeleteChoice(!showDeleteChoice);
    setFlagPopupLeft(target.getBoundingClientRect().right + 10);
    setFlagPopupTop(target.getBoundingClientRect().top);
  };
  return (
    <div className={styles.spacer}>
      <Button onClick={props.onSaveRdv} size="lg">Enregistrer</Button>
      <Button onClick={props.onCancelRdvEdit} variant="secondary" size="lg">
        Annuler modifications
      </Button>
      <div
        className={""}
        onClick={toggleDeleteChoice}
        data-testid="cancelAptButton"
      >
        <Button
          onClick={toggleDeleteChoice}
          size="icon-lg"
          variant="destructive"
          className={styles.colorButton}
          title="Suppr. Rdv"
        >
          <Delete02Icon color="white" />
        </Button>
      </div>
      {showDeleteChoice && (
        <div
          className={styles.deletePopup}
          style={{ top: flagPopupTop, left: flagPopupLeft }}
        >
          {!props.isSecretary && (
            <Button
              onClick={props.onDeleteWithoutLogging}
              data-testid="deleteWithoutLogging"
              variant="destructive"
            >
              Suppression simple
            </Button>
          )}
          <Button
            onClick={
              props.isSecretary
                ? props.onAutoDelete
                : props.onCancelWithLogging
            }
            data-testid={props.isSecretary ? "autoDelete" : "cancelWithLogging"}
            variant="secondary"
          >
            Annulation
          </Button>
          <Button
            onClick={props.onPostPone}
            data-testid="postPone"
            variant="secondary"
          >
            Report
          </Button>
        </div>
      )}
    </div>
  );
};
export default EditRdvButtonsCommit;
